// extracted by mini-css-extract-plugin
export default {"container":"PayBtn_container__-tx8V","red":"PayBtn_red__7r3Mt"};